var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('editable',{ref:"el",attrs:{"tag":_vm.tag},on:{"change":_vm.save,"input":_vm.validate,"enter-key-up":_vm.save},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }